export default "__VITE_ASSET__BBQsWMKn__"